<template>

  <div id="cbinding">


      <div v-if="bindfirst">

            <div class="logout color-l " @click="logout()" v-track="{ name: 'bind_loginout' }">退出</div>

            <img class="bindimg" :src="require('@/assets/bindimg.png')" />

             <div class="bbindfinish" @click="bindfirst = false">
               绑定学生信息
           </div>

      </div>

      <div v-if="!bindfirst">

        <div class="btitle">完善孩子基本信息就能查询成绩</div>

        <div class="bbind">

            <div class="bbind-item">
              <div class="b-item-t">学生姓名<span style="color:#ed5b68">(请实名填写，绑定后不可修改)</span></div>
              <div>
                  <input type="text" v-model="name" placeholder="列如：王丽娟" class="bbind-input">
              </div>
            </div>

            <div class="bbind-item">
              <div  class="b-item-t">省、市</div>
              <div class="binfo" @click="showArea()" v-track="{ name: 'showArea' }">
                  <div class="binfo-l" :class="{ 'select':area.indexOf('例如')== -1 }" >{{area}}</div>
                  <div class="binfo-r">请选择</div>
              </div>
            </div>

            <div class="bbind-item">
              <div  class="b-item-t">所在学校</div>
              <div class="binfo"  @click="showSchool()" v-track="{ name: 'showSchool' }">
                  <div class="binfo-l" :class="{ 'select':sSchool.indexOf('例如')== -1 }">{{sSchool}}</div>
                  <div class="binfo-r">请选择</div>
              </div>
            </div>

            <div class="bbind-item">
              <div  class="b-item-t">所在年级</div>
              <div class="binfo" @click="showGrade()" v-track="{ name: 'showGrade' }">
                  <div class="binfo-l" :class="{ 'select':sGrade.indexOf('例如')== -1 }">{{sGrade}}</div>
                  <div class="binfo-r">请选择</div>
              </div>
            </div>


        </div>

        <div class="bfinish" @click="bind()" v-track="{ name: 'binding' }">
          完成
        </div>

        <van-popup v-model="show" position="bottom" class="mpop" :style="{ 'height': '400px','border-radius':'10px 10px 0px 0px'}" >

            <!-- <van-area title=""
            :columns-num="arenum"
            :area-list="areaList"
            @confirm="areaconfirm"
            @cancel="areacancel"
            @change="areachange"
            /> -->

           <s-area :address="areaList"  @areaselected="areaselected"></s-area>

        </van-popup>

      </div>

  </div>
</template>

<script>

import Popup from 'vant/lib/popup';
import Area from 'vant/lib/area';
import "vant/lib/popup/style";
import "vant/lib/area/style";
import AreaList from "./area.js";
import Sarea from  "@/components/Sarea"

import Toast from 'vant/lib/toast';
import "vant/lib/toast/style";

import { api_bindStudent,api_area } from "@/api"

export default {
  name: 'Binding',
  data(){
    return{
      show:false,
      areaList:null,
      area:"例如：安徽省 合肥市",
      citycode:null,
      grade:"",
      name:null,
      bindfirst:true,
      arenum:3
    }
  },
  created(){
    api_area().then(res=>{
      this.areainfo(res);
    }).catch(ex=>{
      this.areainfo(ex);
    });

    // this.areaList = AreaList;

    this.$store.dispatch('share/initShareParams', {
      title: '七天学堂学情查询',
      desc: '快来看看你的学情分析报告'
    })
    this.$track('start_binding')

  
  },
  components: {
    'van-popup': Popup,
    'van-area':Area,
    's-area':Sarea,


  },
  computed:{
      sSchool(){
          return this.$store.state.bindSchoolinfo ? this.$store.state.bindSchoolinfo.name : "例如：合肥市第一中学";
      },
      sGrade(){
          return this.$store.state.bindGradeInfo ? this.$store.state.bindGradeInfo.name : "例如：高一";
      }
  },
  methods:{
    areachange(event,info){
      if(info[0].code == "110000" || info[0].code == "120000" || info[0].code == "500000" || info[0].code == "310000" ){
        this.arenum = 3;
      }else{
        this.arenum = 2;
      }
    },
    areainfo(info){
      //   let myare = {
      //   'province_list':{},
      //   'city_list':[],
      // }
      // info.map(provinces=>{
      //   myare.province_list[provinces.value]=provinces.text;
      //   let child= provinces.child  || []
      //   child.map(citys=>{ 
      //       myare.city_list[citys.value] = citys.text;
      //   })
      // });
      this.areaList = info;
      // console.log("myare",myare);
    },
    logout(){
      if (this.$route.query.from) {
        this.$router.push({
          path: '/login',
          query: {
            from: this.$route.query.from
          }
        })
      } else {
        this.$router.push({
          path: '/login',
          query: {
            from: encodeURIComponent('/home')
          }
        })
      }
     },
    showArea(){
      if(!this.areaList) return;
      this.show = true;
    },
    showSchool(){
      if(!this.citycode){
          Toast({message:"请先选择城市",duration:2000})
          return;
      }
      this.$router.push('/school');
    },
    showGrade(){
      this.$router.push('/grade');
    },
    bind(){
      if(!this.name){
           Toast({message:"请输入学生姓名",duration:2000})
            return;
      }

      if(!this.$store.state.bindCitycode){
           Toast({message:"请选择省、市",duration:2000})
            return;
      }

      if(!this.$store.state.bindSchoolinfo){
           Toast({message:"请选择学校",duration:2000})
            return;
      }

       if(!this.$store.state.bindGradeInfo){
           Toast({message:"请选择班级",duration:2000})
            return;
      }

      api_bindStudent(this.name,
      this.$store.state.bindSchoolinfo.guid,
      this.$store.state.bindCitycode,
      this.$store.state.bindGradeInfo.value,
      this.$store.state.token
      ).then(res=>{
        this.$store.dispatch('act_getuserInfo').then((res)=>{
          this.$router.back()
        })
      }).catch(ex=>console.log(ex));

    },
    areaselected(address){
      if(address.length == 1){
          this.citycode = address[0]["value"];
          this.area = address[0]['text'] ;
          this.$store.commit('cmtBindCitycode',this.citycode)
      }else{
          this.citycode = address[1]["value"]
          this.area = address[0]['text'] + " "+address[1]['text'];
          this.$store.commit('cmtBindCitycode',this.citycode)
      }
      this.show = false;
    },
    areaconfirm(event){
      // console.log(event);
      // let arr,SelectProvinceName,SelectCityName,SelectCountyName;
      // arr = event;
      // SelectProvinceName = arr[0].name;   // 省
      // SelectCityName = arr[1] && arr[1].name;   // 市
      // SelectCountyName = arr[2] && arr[2].name;  // 区
      // if(arr[0].code == "110000" || arr[0].code == "120000" || arr[0].code == "500000" || arr[0].code == "310000" ){
      //   this.citycode = arr[2]["code"];
      //   this.area = SelectProvinceName + " " + SelectCountyName ;
      // }else{
      //   this.citycode = arr[1]["code"];
      //   this.area = SelectProvinceName + " " + SelectCityName ;
      // }
      // this.$store.commit('cmtBindCitycode',this.citycode)
      // this.show = false;
    }
   
  }
}
</script>

<style lang="scss">

   #cbinding{
        padding: 16px;
        background: #fff;

        .mpop{
            overflow-y: hidden !important;
        
        }

        .bindimg{
          position: absolute;
          width: 300px;
          top:50%;
          left: 50%;
          transform: translate(-50%,-60%);
        }

        .logout{
                border: 1px solid #ed5b68;
                padding: 3px 18px;
                height: 20px;
                border-radius: 13px;
                font-size: 14px;
                position: absolute;
                right: 20px;
                top: 20px;
         }

        .btitle{
          margin-right: 40%;
          font-size: 24px;
          margin-top: 40px;
          font-weight: 450;
        }

        .bbind{
          margin-top: 15px;

          .bbind-item{
            position: relative;
            margin-bottom: 10px;
            padding-bottom: 18px;

            .b-item-t{
                margin-bottom: 7px;
                font-size: 15px;
            }

            .binfo{
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 5px;

              .binfo-l{
                font-size: 16px;
                color: #C5C6C7;

              }

              .select{
                color:#222 !important;
              }
              .binfo-r{
                font-size: 15px;
                color: gray;
              }
            }

            .bbind-input{
              border: none;
              font-size: 16px;
              color:#222;
            }
            .bbind-input::-webkit-input-placeholder {
                color: #C5C6C7;
            }

          }

          .bbind-item::after{
            height: 0.55px;
            content: "";
            width: 100%;
            background: #dadada !important;
            position: absolute;
            right: 0;
            -webkit-transform: scaleY(0.35);
            -ms-transform: scaleY(0.35);
            transform: scaleY(0.35);
            z-index: 99;
            bottom: 0px;
          }


        }

        .bfinish ,.bbindfinish{
            color:white;
            background: #ed5b68;
            width: 90%;
            height: 50px;
            border-radius: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 40px;

        }

        .bfinish{
            margin-left: 5%;
        }

        .bbindfinish{
          position: absolute;
          bottom: 60px;
          left: 5%;
        }

    }

</style>
